import { render, staticRenderFns } from "./disease_research.vue?vue&type=template&id=ad82406e&scoped=true&"
import script from "./disease_research.vue?vue&type=script&lang=js&"
export * from "./disease_research.vue?vue&type=script&lang=js&"
import style0 from "./disease_research.vue?vue&type=style&index=0&id=ad82406e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad82406e",
  null
  
)

export default component.exports